import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Header from "@/components/organisms/common/Header.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import PointCouponList from "@/components/organisms/mypage/PointCouponList.vue";
import PointCard from "@/components/organisms/mypage/PointCard.vue";
import { useRouter } from "vue-router";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import { giftService } from "@/app/services/GiftService";
import { ref, onBeforeMount } from "vue";
import { Gift } from "@/types/Gift";
import { authStore } from "@/store/auth";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExchangeCoupon',
  setup(__props) {

const { back } = useRouter();
const loader = useLoader();
const errorModal = useErrorModal();
const giftList = ref<Gift[]>([]);
const user = authStore.user!;

onBeforeMount(async () => {
  loader.show();
  try {
    await fetchPointGifts();
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
});

const fetchPointGifts = async () => {
  const { results } = await giftService.fetchPointGifts();
  giftList.value = results;
};

const onClickBack = () => {
  back();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      ポイント交換\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createVNode(PointCard, {
      user: _unref(user),
      class: "m-3"
    }, null, 8, ["user"]),
    _createTextVNode(),
    _createVNode(PointCouponList, {
      giftList: giftList.value,
      class: "m-3"
    }, null, 8, ["giftList"])
  ]))
}
}

})